import { on } from 'delegated-events';

on('click', '[data-print]', (event) => {
  event.preventDefault();
  window.print();
});
